<template>
  <SelectBox
    @open="getItems"
    @search="getItems"
    @option:selected="$emit('option:selected', $event)"
    :options="filteredItems"
    :validActivated="validActivated"
    :label="label"
    :noLabel="noLabel"
    :value="value"
    :clearable="clearable"
    :disabled="disabled"
    option-field="name"
    searchable
    @input="$emit('input', $event)"
  >
    <template #selected-option="{ item }">
      {{ item.name }}
    </template>
    <template #option="{ item }">
      {{ item.name }}
    </template>
    <template #not-auth v-if="$status.series === 'NOT_AUTHORIZED'">
      <not-auth></not-auth>
    </template>
  </SelectBox>
</template>

<script>
import Requests from "@/services/Requests";
import SelectBox from "../Base/Inputs/SelectBox.vue";
export default {
  components: {
    SelectBox,
  },
  data() {
    return {
      items: [],
      search: "",
    };
  },
  props: {
    value: {
      default: null,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    validActivated: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) =>
        item.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    /**
     * Makes a request to get all batteries that match the given search query.
     *
     * @param {string} search - search query to send to the API
     * @param {function} loading - function to call when the request is sending or done. Pass true to indicate sending, false to indicate done.
     */
    async getItems(search, loading) {
      this.search = search;
      if (this.items.length > 0) return loading(false);
      loading(true);
      const response = await Requests.Tks.GetGrainNames({
        query: { search: search },
      });
      this.$status.series = response.message;
      if (response.message === "OK") {
        this.items = response.data.map((item) => ({
          ...item,
          permeability: this.convertEnumberToString(item.permeability),
        }));
      } else {
        this.items = [];
      }
      loading(false);
    },
    convertEnumberToString(number) {
      // example number is: 5.78e-9
      // we need to convert it to: 0.00000000578
      if (number.toString().includes("e-")) {
        const [base, exponent] = number.toString().split("e-");
        const baseNumber = base.replace(".", "");
        const exponentNumber = parseInt(exponent);
        const numberOfRight = `0.${"0".repeat(
          exponentNumber - 1
        )}${baseNumber}`;
        return numberOfRight;
      }
      return number.toString();
    },
  },
};
</script>

<style></style>
